export const ChatbotSessionId = 'chatbot-session-id'
export const SiteListFirst = 'site-list-first'
